export const onClickGetInTouch = () =>{
    const emailAddress = 'contact@example.com'; // Replace with your contact email address
    const subject = 'Regarding your inquiry'; // Replace with your desired subject
    const body = 'Dear Team,\n\nI am contacting you about...'; // Replace with your desired email body

    const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Open the default email client with prefilled data
    window.location.href = mailtoLink;
}